import React from 'react';
import styles from './css/CTABlock.styl';
import {FormControls} from '../../../../shared/library';
import classNames from 'classnames';

const {Button} = FormControls;

const CTABlock = props => {
  const {blurb, button, className, seo, title, newWindow} = props;

  const handleClick = () => {
    if (newWindow) {
      if (window) {
        window.open(button.href, '_blank');
      }
    } else if (document && document.location) {
      document.location.href = button.href;
    }
  };

  return (
    <div className={classNames(styles.CTABlock, styles[className])}>
      {seo === 'h2' ? (
        <h2 className={styles.Title}>{title}</h2>
      ) : (
        <div className={styles.Title}>{title}</div>
      )}
      <div className={styles.Blurb}>{blurb}</div>
      {button && (
        <Button
          className={styles[button.class || 'Button']}
          handleClick={handleClick}
        >
          {button.text}
        </Button>
      )}
    </div>
  );
};

CTABlock.propTypes = {
  blurb: React.PropTypes.string,
  button: React.PropTypes.object,
  className: React.PropTypes.string,
  seo: React.PropTypes.string,
  title: React.PropTypes.string,
  newWindow: React.PropTypes.bool,
};

export default CTABlock;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/CTABlock/index.js